export default __webpack_public_path__ + "static/media/react_hooks.23352e24.png";